module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av0409-9485770aca2f221de631511c528ce116.jpg";